import { CompartmentRuleItem } from '../../../../administration/compartment/models';
import { LocalDateRangeModel } from '../../../../../models';

export interface AllocationUliRulesResponse {
  rules: CompartmentRuleItem[];
  timezone: string;
}

export interface AllocationUliRuleSlot {
  registered: boolean;
  slotId: string;
  timeFrame: LocalDateRangeModel;
}
